// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/style-loader!./~/css-loader?sourceMap!./~/cssnext-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/guestroom.vue
// module id = 86
// module chunks = 0